import theme from "@shared/utils/themeColors";

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * A customizable loading spinner component
 */
export function LoadingSpinner({ size = 'md', className = '' }: LoadingSpinnerProps) {
  // Define sizes
  const sizes = {
    sm: 'h-4 w-4 border-b-1',
    md: 'h-8 w-8 border-b-2',
    lg: 'h-12 w-12 border-b-3',
  };

  return (
    <div
      className={`animate-spin rounded-full ${sizes[size]} ${theme.border.brand} ${className}`}
    ></div>
  );
}
